/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/no-array-index-key */
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  HeadingDescSmall,
  HeadingDescVsmall,
  HeadingWithSpaceLarge
} from '../../../Components/Headings';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import {
  AncerWithUnderlineSmall
} from '../../../Components/button';
import { SectionHeading } from '../../../Components/SectionHeading';
import CardWithLeftImage from '../../../Components/Card/cardWithLeftImage/CardWithLeftImage';
import pdfIcon from '../../../assets/images/png/pdf.png';
import jpgIcon from '../../../assets/images/png/jpg-icon.png';
import arrowRight from '../../../assets/images/svg/right-arrow-border.svg';
import closeIcon from '../../../assets/images/png/close-table.png';
import backIcon from '../../../assets/images/svg/left-arrow-with-border.svg';
import editIcon from '../../../assets/images/png/edit-table.png';
import shareIcon from '../../../assets/images/png/share-table.png';
import docImg from '../../../assets/images/png/doc.png';
import './viewMedicalRecords.css';

const shareWithDoctors = [
  {
    image: docImg,
    name: 'Prof. Dr. Nadia Khurshid Ahmed',
    speciality: 'Gynecologist, Obstetrician',
    sharedOn: 'Shared on March 25, 2021'
  },
  {
    image: docImg,
    name: 'Prof. Dr. Nadia Khurshid Ahmed',
    speciality: 'Gynecologist, Obstetrician',
    sharedOn: 'Shared on March 25, 2021'
  }
];

function ViewMedicalRecords() {
  return (
    <HealthCheckLayout>
      <section className="viewMedicalRecords bgLinghtGray">
        <Container>
          <div className="addBox">
            <Link to="/medicalRecordes">
              <img src={backIcon} alt="backIcon" />
            </Link>
            <HeadingWithSpaceLarge text="VIEW MEDICAL RECORD" />
          </div>
          <form>
            <div className="innerBox">
              <Row>
                <Col md={12}>
                  <div className="shareEditContainer">
                    <SectionHeading
                      icon={<img src={editIcon} alt="editIcon" />}
                      link={<AncerWithUnderlineSmall text="edit" to="/" />}
                    />
                    <SectionHeading
                      icon={<img src={shareIcon} alt="editIcon" />}
                      link={
                        <AncerWithUnderlineSmall
                          text="share with doctors"
                          to="/"
                        />
                      }
                    />
                  </div>
                </Col>
              </Row>
              <div className="secondRowContainer">
                <Row>
                  <Col md={2}>
                    <div className="textBox">
                      <HeadingDescSmall text="Tests Taken on" />
                      <HeadingDescSmall text="March 15, 2021" />
                    </div>
                  </Col>
                  <Col md={2}>
                    <div className="textBox">
                      <HeadingDescSmall text="Reports for" />
                      <HeadingDescSmall text="Alyna Butt (You)" />
                    </div>
                  </Col>
                  <Col md={2}>
                    <div className="textBox">
                      <HeadingDescSmall text="Total Reports" />
                      <HeadingDescSmall text="3 Reports" />
                    </div>
                  </Col>
                  <Col md={6} />
                  <Col md={4}>
                    <div className="sharedDoctorsContainer">
                      <HeadingDescSmall text="Shared with Doctor(s)" />
                      {shareWithDoctors.map((shareWith, index) => {
                        const { image, name, speciality, sharedOn } = shareWith;
                        return (
                          <CardWithLeftImage
                            key={index}
                            image={image}
                            heading={name}
                            desc={speciality}
                          >
                              <HeadingDescVsmall text={sharedOn} />
                          </CardWithLeftImage>
                        );
                      })}
                    </div>
                  </Col>
                  <Col md={5}>
                    <div className="pdfArea">
                      <div className="pdfContainer">
                        <div className="pdfBox">
                          <button type="button" className="closeIcon">
                            <img src={closeIcon} alt="closeIcon" />
                          </button>
                          <img src={pdfIcon} alt="pdf" className="pdfImage" />
                          <div className="btnBox">
                            <img src={arrowRight} alt="arrowRight" />
                            <AncerWithUnderlineSmall text="view" />
                          </div>
                        </div>
                        <div className="pdfBox">
                          <button type="button" className="closeIcon">
                            <img src={closeIcon} alt="closeIcon" />
                          </button>
                          <img src={pdfIcon} alt="pdf" className="pdfImage" />
                          <div className="btnBox">
                            <img src={arrowRight} alt="arrowRight" />
                            <AncerWithUnderlineSmall text="view" />
                          </div>
                        </div>
                        <div className="pdfBox">
                          <button type="button" className="closeIcon">
                            <img src={closeIcon} alt="closeIcon" />
                          </button>
                          <img src={jpgIcon} alt="pdf" className="pdfImage" />
                          <div className="btnBox">
                            <img src={arrowRight} alt="arrowRight" />
                            <AncerWithUnderlineSmall text="view" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </form>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default ViewMedicalRecords;
